/**
 * AppKeyboardShortcutsHotkeys bond setup
 *
 * Wires @molecule/app-keyboard-shortcuts-hotkeys to @molecule/app-keyboard-shortcuts
 * (`/` focuses the catalog search, `mod+k` opens quick search).
 */

import { setProvider } from '@molecule/app-keyboard-shortcuts'
import { provider } from '@molecule/app-keyboard-shortcuts-hotkeys'

export function setupAppKeyboardShortcutsHotkeys(): void {
  setProvider(provider)
}
